import { createRouter, createWebHistory } from 'vue-router'
// createWebHistory

const routes = [
    {
        path: "/",
        name: "login",
        component: () => import("../views/login/index.vue")
    },
    {
        path: "/a",
        name: "externalDownload",
        component: () => import("../views/externalDownload/index.vue")
    },
    {
        path: "/app/list",
        name: "externalDownloadList",
        component: () => import("../views/externalDownload/list.vue")
    },
    {
        path: "/phoneDown",
        name: "phoneDown",
        component: () => import("../views/phoneDown/index.vue")
    },
    {
        path: "/singleDown",
        name: "singleDown",
        component: () => import("../views/phoneDown/singleDown.vue")
    },
    {
        path: "/down/history",
        name: "history",
        component: () => import("../views/phoneDown/history.vue")
    },
    {
        path: "/layout",
        name: "layout",
        component: () => import("../views/layout/index.vue"),
        children: [
            {
                path: "/downloads",
                name: "downloads",
                component: () => import("../views/downloads/index.vue")
            },
            {
                path: "/downloadList",
                name: "downloadList",
                component: () => import("../views/downloads/list.vue")
            },
            {
                path: "/creates",
                name: "creates",
                component: () => import("../views/creates/index.vue")
            },
            {
                path: "/updates",
                name: "updates",
                component: () => import("../views/updates/index.vue")
            },
            {
                path: "/uploadPack",
                name: "uploadPack",
                component: () => import("../views/updates/uploadPack.vue")
            },
        ]
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    // history: createWebHashHistory(), // 不需要重定向
    routes
})

export default router
